export const adaptPresentacionNutricion = (presentacionNutricionData) => {
    return {
        id: presentacionNutricionData?.idPresentacionNutricion,
        displayName: presentacionNutricionData?.descripcion,
    }
}

export const adaptPresentacionNutricionArray = (
    presentacionNutriciones
) => {
    return structuredClone(presentacionNutriciones?.allPresentacionNutricion)
        ?.map(presentacionNutricion => adaptPresentacionNutricion(presentacionNutricion));
}